export const pendingBackgroundColor = [
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
  "#2C3E50",
  "#1ABC9C",
  "#6c6e15",
  "#3498DB",
  "#9B59B6",
  "#F39C12",
  "#2ECC71",
  "#D35400",
  "#8E44AD",
  "#16A085",
  "#27AE60",
  "#C0392B",
  "#F1C40F",
  "#7F8C8D",
];
export const rejectedBackgroundColor = [
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFEB3B",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#9E9E9E",
  "#607D8B",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFEB3B",
  "#FFC107",
];
